var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaparazzoLogoVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    "data-name": "Livello 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 436.5 242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff0098;\n      }\n\n      .cls-2 {\n        fill: #5d5d5d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2-2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m198.82,0h-50.01v50.01c6.76-24.2,25.81-43.25,50.01-50.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m287.69,50.01V0h-50.01c24.2,6.76,43.25,25.81,50.01,50.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m148.81,88.87v50.01h50.01c-24.2-6.76-43.25-25.81-50.01-50.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m237.68,138.89h50.01v-50.01c-6.76,24.2-25.81,43.25-50.01,50.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m233.85,51.25c0-2.19.62-4.23,1.68-5.97-4.87-3.45-10.81-5.5-17.24-5.5-16.46,0-29.81,13.3-29.81,29.71s13.35,29.71,29.81,29.71,29.81-13.3,29.81-29.71c0-2.35-.3-4.63-.82-6.83-.6.09-1.2.16-1.83.16-6.41,0-11.61-5.18-11.61-11.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m257.07,51.25c0-6.39-5.2-11.57-11.61-11.57-4.21,0-7.89,2.25-9.93,5.59,5.81,4.12,10.06,10.25,11.75,17.39,5.54-.87,9.78-5.64,9.78-11.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tipografia"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m0,179.61h11.74v5.81c3.79-4.75,9.24-6.78,14.78-6.78,12.75,0,20.89,11.24,20.89,25.09s-8.32,25.29-21.07,25.29c-5.36,0-10.63-2.23-13.95-6.49v19.47H0v-62.39Zm34.75,24.22c0-7.65-4.71-13.18-11.46-13.18-6.28,0-11,5.43-11,13.18s4.62,13.18,11,13.18c6.74,0,11.46-5.52,11.46-13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m53.05,203.83c0-13.95,8.13-25.19,20.88-25.19,5.36,0,11.09,2.23,14.42,6.88v-5.91h12.11v48.44h-12.11v-5.81c-3.23,4.65-9.05,6.78-14.42,6.78-12.75,0-20.88-11.24-20.88-25.19Zm35.02,0c0-7.56-4.62-13.18-11-13.18s-11.46,5.62-11.46,13.18,4.8,13.18,11.46,13.18,11-5.43,11-13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m108.88,179.61h11.74v5.81c3.79-4.75,9.24-6.78,14.78-6.78,12.75,0,20.89,11.24,20.89,25.09s-8.32,25.29-21.07,25.29c-5.36,0-10.63-2.23-13.95-6.49v19.47h-12.38v-62.39Zm34.75,24.22c0-7.65-4.71-13.18-11.46-13.18-6.28,0-11,5.43-11,13.18s4.62,13.18,11,13.18c6.74,0,11.46-5.52,11.46-13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m161.92,203.83c0-13.95,8.13-25.19,20.89-25.19,5.36,0,11.09,2.23,14.42,6.88v-5.91h12.11v48.44h-12.11v-5.81c-3.23,4.65-9.06,6.78-14.42,6.78-12.75,0-20.89-11.24-20.89-25.19Zm35.02,0c0-7.56-4.62-13.18-11-13.18s-11.46,5.62-11.46,13.18,4.81,13.18,11.46,13.18,11-5.43,11-13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m217.74,179.61h12.2v9.3c1.29-3.97,6.01-10.27,16.17-10.27v14.14c-10.72,0-15.99,5.13-15.99,16.66v18.6h-12.38v-48.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m248.11,203.83c0-13.95,8.13-25.19,20.89-25.19,5.36,0,11.09,2.23,14.42,6.88v-5.91h12.11v48.44h-12.11v-5.81c-3.23,4.65-9.06,6.78-14.42,6.78-12.75,0-20.89-11.24-20.89-25.19Zm35.02,0c0-7.56-4.62-13.18-11-13.18s-11.46,5.62-11.46,13.18,4.81,13.18,11.46,13.18,11-5.43,11-13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m303.33,218.45l15.43-20.49c2.4-3.07,6.74-7.72,6.74-7.72h-21.25v-11.68h36.5v9.5l-15.53,20.19c-2.59,3.46-6.93,8.11-6.93,8.11h23.19v11.68h-38.16v-9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m344.74,218.45l15.43-20.49c2.4-3.07,6.74-7.72,6.74-7.72h-21.25v-11.68h36.5v9.5l-15.52,20.19c-2.59,3.46-6.93,8.11-6.93,8.11h23.19v11.68h-38.16v-9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m387.06,203.83c0-14.05,10.9-25.19,24.67-25.19s24.77,11.14,24.77,25.19-10.9,25.19-24.77,25.19-24.67-11.14-24.67-25.19Zm36.78,0c0-7.56-5.17-13.18-12.1-13.18s-12.11,5.62-12.11,13.18,5.17,13.18,12.11,13.18,12.1-5.52,12.1-13.18Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaparazzoLogoVertical);
export default __webpack_public_path__ + "static/media/paparazzo_logo_vertical.c4ef4e891ec8de66ceb232aaac8af98c.svg";
export { ForwardRef as ReactComponent };